import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import DownloadOptions from './downloads/DownloadOptions'

const Downloads = () => {
  const { t } = useTranslation('proposals')

  return (
    <Wrapper>
      <DescriptionContainer>
        <p>
          {t(
            'The processing and loading time for larger datasets can take several minutes.'
          )}
        </p>
        <p>
          {t(
            'Notice Regarding the Anonymity of Downloadable Files. The metadata of downloadable materials has not been specifically reviewed to ensure anonymity. The materials are provided in the form submitted by competitors (except for cleaned or ID-coded file names). It is the downloader’s responsibility to review the content and address any information that may compromise anonymity as needed. We recommend exercising caution, especially if the materials are shared further in file format. In materials accessed via the Competition Cloud interface, metadata has been filtered to ensure anonymity, making it the recommended method for sharing competition entries with the jury.'
          )}
        </p>
      </DescriptionContainer>
      <DownloadOptions />
    </Wrapper>
  )
}

export default Downloads

const Wrapper = styled.div`
  margin-top: 20px;
`

const DescriptionContainer = styled.div`
  margin-bottom: 20px;
  font-size: 16px;
  color: #000;

  p {
    margin-top: 0;
  }
`
